<div class="settlements-send-check first">
    <div class="header">
        <div class="container">
            <div class="content justify-content-center">
                <mat-checkbox [formControl]="fcHideSent"> Verberg verstuurde boekingsregels </mat-checkbox>
                <mat-checkbox [formControl]="fcShowOnlyMissing"> Toon alleen incomplete regels </mat-checkbox>
                @if (!hideDateSelection) {
                    <mat-form-field>
                        <input
                            [matDatepicker]="pickerStart"
                            [formControl]="fcEndDate"
                            (focus)="pickerStart.open()"
                            matInput
                            placeholder="Einddatum" />
                        <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
                        <mat-datepicker #pickerStart></mat-datepicker>
                        @if (fromDate) {
                            <mat-hint>Vanaf {{ fromDate | date: 'EEEE d MMM yyyy' }}</mat-hint>
                        }
                    </mat-form-field>
                }
                @if (!settlementsSubscription$) {
                    <button
                        class="planning-button"
                        [disabled]="itemsToSend === 0"
                        (click)="sendAllToAfas()"
                        mat-raised-button
                        color="primary">
                        Verstuur openstaande boekingsregels ({{ itemsToSend }})
                    </button>
                }
                @if (settlementsSubscription$) {
                    <button class="planning-button" (click)="cancelSendToAfas()" mat-raised-button color="primary">
                        Stoppen met versturen ({{ itemsToSend }})
                    </button>
                }
            </div>
        </div>
    </div>
</div>

<div class="settlements-send-check last">
    @if (allSettlements) {
        <div class="list">
            @for (settlement of allSettlements; track settlement; let even = $even) {
                @if (
                    !(
                        fcHideSent.value &&
                        (settlement.minutes === 0 || settlement.afas_ptrealization_id) &&
                        !settlement.afas_error
                    ) && !(fcShowOnlyMissing.value && !settlement.missing_values && !settlement.afas_error)
                ) {
                    <div class="list-item" [class.warn]="!even">
                        <div class="container">
                            <div class="content">
                                <div class="name-wrapper">
                                    <div class="name">
                                        {{ settlement.user?.name }}
                                    </div>
                                    <div class="caption curpoint" (click)="editSettlement(settlement, 'hourtype')">
                                        {{ settlement.hourtype?.description }} ({{ settlement.hourtype?.code }})
                                    </div>
                                    <div class="caption description">
                                        {{ settlement.bookdate | date: 'dd MMMM yyyy' }}<br />
                                        <small>{{ settlement.description }}</small>
                                    </div>
                                </div>
                                <div class="prefix">
                                    @if (settlement.missing_values && !settlement.afas_ptrealization_id) {
                                        <button class="icon-button invalid" mat-icon-button disabled>
                                            <i
                                                class="fa-light fa-person-circle-exclamation"
                                                matTooltip="Missende waarden"></i>
                                        </button>
                                    }
                                    @if (!settlement.send_to_afas && !settlement.missing_values) {
                                        <button class="icon-button" mat-icon-button disabled>
                                            <i class="fa-light fa-user-clock" matTooltip="Wacht op versturen"></i>
                                        </button>
                                    }
                                    @if (
                                        !settlement.afas_ptrealization_id &&
                                        settlement.send_to_afas &&
                                        !settlement.afas_error &&
                                        settlement.minutes !== 0
                                    ) {
                                        <button class="icon-button" mat-icon-button disabled>
                                            <i class="fa-light fa-hourglass-clock" matTooltip="Wordt verstuurd"></i>
                                        </button>
                                    }
                                    @if (settlement.afas_ptrealization_id) {
                                        <button class="icon-button valid" mat-icon-button disabled>
                                            <i class="fa-light fa-check" matTooltip="Is verstuurd"></i>
                                        </button>
                                    }
                                    @if (settlement.send_to_afas && settlement.minutes === 0) {
                                        <button class="icon-button valid" mat-icon-button disabled>
                                            <i
                                                class="fa-light fa-check"
                                                matTooltip="Nulwaarde, versturen niet nodig"></i>
                                        </button>
                                    }
                                    @if (settlement.sent_to_afas && settlement.afas_error) {
                                        <button class="icon-button invalid" mat-icon-button disabled>
                                            <i
                                                class="fa-light fa-circle-exclamation"
                                                matTooltip="Fout bij versturen"></i>
                                        </button>
                                    }
                                </div>
                                <div class="times">
                                    <div class="top">
                                        <div class="time">
                                            {{ settlement.minutes | minutes }}<br />
                                            <small>{{ settlement.amount }}</small
                                            ><br />
                                        </div>
                                        <div
                                            class="time"
                                            [class.downlight]="!settlement.afas_project_id"
                                            (click)="editSettlement(settlement, 'project')">
                                            {{
                                                settlement.afas_project_id ??
                                                    settlement.realisation?.afas_project_id ??
                                                    settlement.realisation?.planning?.afas_project_id ??
                                                    settlement.realisation?.user_planning?.afas_project_id ??
                                                    '-'
                                            }}
                                            <br />
                                            <small>Project</small><br />
                                        </div>
                                        <div
                                            class="time"
                                            [class.downlight]="!settlement.afas_employee_id"
                                            [class.difference]="
                                                !(settlement.afas_employee_id ?? settlement.user?.afas_employee_id)
                                            ">
                                            {{ settlement.afas_employee_id ?? settlement.user?.afas_employee_id ?? '-'
                                            }}<br />
                                            <small>Medewerker</small><br />
                                        </div>
                                        @if (settlement.send_to_afas) {
                                            <div class="time">
                                                #{{ settlement.afas_ptrealization_id ?? '-' }}<br />
                                                <small>Afas</small><br />
                                            </div>
                                        }
                                    </div>
                                    @if (settlement.afas_ptrealization_id && !settlement.afas_error) {
                                        <div class="comments valid">
                                            <i
                                                >Verstuurd naar Afas op
                                                {{ settlement.sent_to_afas | date: 'EEE dd MMM yyyy, HH:mm' }}</i
                                            >
                                        </div>
                                    }
                                    @if (settlement.afas_error) {
                                        <div class="comments invalid">
                                            <i>Fout bij versturen naar Afas:</i>
                                            {{ settlement.afas_error }}
                                        </div>
                                    }
                                </div>
                                <div
                                    class="buttons"
                                    [matTooltip]="
                                        settlement.missing_values
                                            ? 'Project of medewerker is niet juist gevuld'
                                            : 'Verstuur naar Afas'
                                    ">
                                    @if (!settlement.afas_ptrealization_id) {
                                        <button
                                            class="planning-button"
                                            [disabled]="settlement.missing_values || !!settlement.afas_ptrealization_id"
                                            (click)="sendToAfas(settlement)"
                                            mat-icon-button
                                            color="primary">
                                            @if (!settlement.send_to_afas || settlement.afas_error) {
                                                <i class="fas fa-paper-plane-top"></i>
                                            }
                                            @if (settlement.send_to_afas && !settlement.sent_to_afas) {
                                                <i class="fa-duotone fa-loader fa-spin"></i>
                                            }
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
            }
            @if (sentCount > 0 && fcHideSent.value) {
                <div class="list-item" (dblclick)="fcHideSent.setValue(false)">
                    <div class="container text-center font-italic py-3">
                        Er zijn {{ sentCount }} verborgen verstuurde regels
                    </div>
                </div>
            }
            @if (correctCount > 0 && fcShowOnlyMissing.value) {
                <div class="list-item" (dblclick)="fcShowOnlyMissing.setValue(false)">
                    <div class="container text-center font-italic py-3">
                        Er zijn {{ correctCount }} verborgen complete regels, waarvan {{ itemsToSend }} nog verstuurd
                        moeten worden
                    </div>
                </div>
            }
        </div>
    }
</div>
